module.exports = __webpack_public_path__ + "img/gpp_good_black_24dp.49ec8d2c.svg";